import { render, staticRenderFns } from "./MilestoneTaskBoardPhaseDurationView.vue?vue&type=template&id=39d768cb&"
import script from "./MilestoneTaskBoardPhaseDurationView.vue?vue&type=script&lang=js&"
export * from "./MilestoneTaskBoardPhaseDurationView.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTaskBoardPhaseDurationView.vue?vue&type=style&index=0&id=39d768cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports